import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';

// Services
import { FirmService } from '../../../../Services/firm.service';
import { FirmSelectionService } from '../../../../Services/firm-selection.service';
import { NotificationService } from '../../../../Services/notification.service';
import { AuthService } from '../../../../Services/auth.service';
import { UserAccessService } from '../../../../Services/UserAccess/user-access.service';
import { UserServiceService } from '../../../../Services/user.service';
import { CustomizeService } from '../../../../Services/Customize_settings/customize.service';

@Component({
  selector: 'app-rmportal-header',
  imports: [NgIf, NgClass, NgFor, RouterLink, FormsModule],
  templateUrl: './rmportal-header.component.html',
  styleUrl: './rmportal-header.component.css'
})
export class RmportalHeaderComponent implements OnInit {

  firmnames: string[] = [];
  selectedFirm: string | null | undefined;
  userImg: any;
  isFirmLocked: boolean = false;

  router = inject(Router);
  menuOpen = false;
  mobileExpanded: string | null = null;

  // Loader State
  isLoading = false;
  logoImage: any;

  // 1. HARDCODED MENU OPTIONS (Default visible: false to prevent flash)
  navbarOptions = [
    {
      lable: 'Staff Dashboard',
      path: '/rm-portal/home',
      visible: false,
      submenu: []
    },
    {
      path: '/add-ready-product',
      lable: 'Ready Product Line',
      visible: false,
      submenu: [
        { path: '/add-ready-product', lable: 'Add Ready Product', visible: false },
      ]
    },
    {
      path: '/raw-metal/metal',
      lable: 'Assembly Line',
      visible: false,
      submenu: [
        { path: '/product-creation', lable: 'Create Product', visible: false },
        { path: '/raw-metal/metal', lable: 'Add Raw Material', visible: false },
        { path: '/order/order-creation', lable: 'Order Creation', visible: false },
        { path: '/design-product', lable: 'Designed Product List', visible: false },
        { path: '/available-to-produce', lable: 'Available To Produce (ATP)', visible: false },
        { path: '/material-requirement-sheet', lable: 'Material Requirement Sheet (MRS)', visible: false },
        { path: '/combo-creation', lable: 'Combo Creation', visible: false },
      ]
    },
    {
      path: '/packaging-form',
      lable: 'Packaging',
      visible: false,
      submenu: [
        { path: '/packaging-form', lable: 'New Packaging Entry', visible: false },
        { path: '/packaging-stack-form', lable: 'Create Packaging Stack', visible: false },
      ]
    },
    {
      path: '/product-tagging',
      lable: 'Tag',
      visible: false,
      submenu: [
        { path: '/product-tagging', lable: 'Product Tagging', visible: false },
        { path: '/taggings-list', lable: 'Taggings list', visible: false, key: 'taggings_list' },
        { path: '/tag-labels', lable: 'Tag Label', visible: false },
      ]
    },
    {
      path: '/report',
      lable: 'Report',
      visible: false,
      submenu: [
        { path: '/report/fine-jewellery', lable: 'Fine Jewellery', visible: false, key: 'fine_jewellery' },
        { path: '/report/imitation-jewellery', lable: 'Imitation Jewellery', visible: false, key: 'imitation_jewelry' },
        { path: '/report/general-list', lable: 'Assembly Product', visible: true, key: 'assembly_product' },
        { path: '/report/raw-metal', lable: 'Raw Metal', visible: false, key: 'raw_metal' },
        { path: '/report/raw-metal-stock', lable: 'Raw Metal', visible: false, key: 'raw_metal_stock' },
        { path: '/report/stone-stock', lable: 'Raw Stone', visible: false, key: 'stone_stock' },
        { path: '/report/stock-tally', lable: 'Stock Tally', visible: false, key: 'stock_tally' },
        { path: '/report/ready-product-list', lable: 'Ready Product List', visible: false, key: 'ready_product_stock' },
        { path: '/report/reorder-list', lable: 'Re-Order List', visible: false, key: 'reorder_list' },
        { path: '/report/stock-ins', lable: 'Stocks', visible: false, key: 'stock_ins' },
        { path: '/report/stock-list', lable: 'Stocks List', visible: false, key: 'stock_list' },
        { path: '/report/other-panel', lable: 'Other Panel', visible: false, key: 'other_panel' },
        { path: '/report/stock-packaging-list', lable: 'Stock Packaging list', visible: false, key: 'stock_packaging_list' },
        { path: '/report/packaging-stack-list', lable: 'Packaging Stack list', visible: false, key: 'stock_packaging_list' },
        { path: '/invoice-report', lable: 'Sell Invoice Report', visible: false, key: 'sell_invoice_report' }

      ]
    },
    { path: '/rm-portal', lable: 'Sales Executive', visible: false },
    // { path: '/#', lable: 'Scheme', visible: false },
    // { path: '/#', lable: 'Loan', visible: false },
    // { path: '/#', lable: 'Cr/Dr', visible: false },
    // { path: '/#', lable: 'Expense', visible: false },
    {
      path: '/user-list',
      lable: 'User List',
      visible: false,
      submenu: [
        { path: '/user-list/customer-list', lable: 'Customer List', visible: false },
        { path: '/user-list/staff-list', lable: 'Staff List', visible: false },
        { path: '/user-list/supplier-list', lable: 'Supplier List', visible: false },
        { path: '/user-list/investor-list', lable: 'Investor List', visible: false },
        { path: '/create-user/add-customer', lable: 'Add Customer', visible: false },
        { path: '/create-user/add-staff', lable: 'Add Staff', visible: false },
        { path: '/create-user/add-supplier', lable: 'Add Supplier', visible: false },
        { path: '/create-user/add-investor', lable: 'Add Investor', visible: false },
      ]
    },
    {
      lable: 'Sell',
      path: '/rm-portal/sell-customer',
      visible: false,
      submenu: []
    },
    {
      lable: 'Stock',
      path: 'rm-portal/new-stock',
      visible: false,
      submenu: [
        { lable: 'New Stock', path: 'rm-portal/new-stock', visible: false },
        { lable: 'Available Stock', path: '/rm-portal/available-stock', visible: false },
        { lable: 'Submitted Stock', path: '/rm-portal/submitted-stock', visible: false },
        { lable: 'Sold Stock', path: '/rm-portal/sold-stock', visible: false }
      ]
    },
    {
      lable: 'Sales',
      path: '/rm-portal/sales-history',
      visible: false,
      submenu: []
    },
    {
      lable: 'Udhar',
      path: '/rm-portal/udhar',
      visible: false,
      submenu: []
    },
    {
      lable: 'Accounts',
      path: '/rm-portal/incentive',
      visible: false,
      submenu: [
        { lable: 'Incentives', path: '/rm-portal/incentive', visible: false },
        { lable: 'Expenses', path: '/rm-portal/expense', visible: false },
        { lable: 'Assets', path: '/rm-portal/assets', visible: false },
      ]
    },
    {
      lable: 'Customer List',
      path: 'user-list/customer-list',
      visible: false,
      submenu: []
    },
    // Added for Direct Cash/Metal by Pratik (24-06-2026)
    {
      lable: 'Direct Cash/Metal',
      path: '/direct-entry',
      visible: false,
      submenu: [
        { lable: 'Direct Entries List', path: '/direct-entry', visible: false },
      ]
    },
    { path: '/admin-panel', lable: 'Settings', visible: false }
  ];

  constructor(
    private firmService: FirmService,
    private firmSelectionService: FirmSelectionService,
    private notificationService: NotificationService,
    private authService: AuthService,
    private userAccessService: UserAccessService,
    private userService: UserServiceService,
    private customizeService: CustomizeService
  ) { }

  ngOnInit(): void {
    // 🔥 Listen for logo changes
    this.customizeService.logo$.subscribe((logo) => {
      if (logo) {
        this.logoImage = logo;
      }
    });
    const userRole = sessionStorage.getItem('role');
    this.isFirmLocked = (sessionStorage.getItem('is_firm_restricted') === 'true') || (userRole === 'Staff');
    this.loadFirms();
    this.getProfile(this.authService.getUserId());

    this.firmService.firmsUpdated$.subscribe(() => {
      this.loadFirms();
    });

    this.loadUserPermissions();
  }

  getProfile(id: any) {
    this.userService.getCurrentUserProfile(id).subscribe((res: any) => {
      this.userImg = res?.data?.[0]?.doc_user_img;
      console.log('check user img', this.userImg, res.data);
    });
  }

  loadUserPermissions() {
    const userId = this.authService.getUserId();

    // Validate User exists
    if (!userId) {
      console.error('No User ID found');
      return;
    }

    // START LOADING
    this.isLoading = true;

    // Use Service call
    this.userAccessService.getUserAccess(userId).subscribe({
      next: (response) => {
        const perms = response.data;

        if (perms) {
          const allowedMain = perms.mainmenu_visibility || [];
          const allowedSub = perms.submenu_visibility || [];
          this.applyPermissions(allowedMain, allowedSub);
        } else {
          // New user, keep everything false
          this.applyPermissions([], []);
        }

        // STOP LOADING
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Failed to load permissions', err);
        // Ensure loader stops even on error
        this.isLoading = false;
      }
    });
  }

  applyPermissions(allowedMain: string[], allowedSub: string[]) {
    this.navbarOptions.forEach(menu => {
      // Main Menu (Always allow Staff Dashboard by default)
      if (menu.path === '/rm-portal/home' || allowedMain.includes(menu.path)) {
        menu.visible = true;
      }

      // Submenu
      if (menu.submenu && menu.submenu.length > 0) {
        menu.submenu.forEach(sub => {
          if (allowedSub.includes(sub.path)) {
            sub.visible = true;
          }
        });
      }
    });
  }

  // ... Rest of your component code ...

  toggleMenu() { this.menuOpen = !this.menuOpen; }
  toggleSubmenu(path: string) { this.mobileExpanded = this.mobileExpanded === path ? null : path; }
  navigateTo(path: string) {
    this.router.navigate([path]);
    this.menuOpen = false;
    this.mobileExpanded = null;
  }

  onFirmChange(name: string) {
    this.firmService.getFirms().subscribe((response: any) => {
      const firm = response.data.find((f: any) => f.name === name);
      if (firm) {
        this.firmSelectionService.setselectedFirmName({ id: firm.id, name: firm.name, status: firm.gst_status });
      }
    });
  }

  private loadFirms() {
    this.firmService.getFirms().subscribe((response: any) => {
      const firms = response.data;
      this.firmnames = firms.map((firm: any) => firm.name);

      this.firmSelectionService.selectedFirmName$.subscribe(firm => {
        if (firm) {
          const isGst = this.firmSelectionService.isGstFirm(firm.status, firm.name);
          if (isGst) {
            const nonGstFirm = firms.find((f: any) => !this.firmSelectionService.isGstFirm(f.gst_status, f.name));
            if (nonGstFirm) {
              this.selectedFirm = nonGstFirm.name;
              this.firmSelectionService.setselectedFirmName({ id: nonGstFirm.id, name: nonGstFirm.name, status: nonGstFirm.gst_status });
              return;
            }
          }
          this.selectedFirm = firm.name;
        }
      });

      const currentFirm = this.firmSelectionService.getselectedFirmName();
      const isCurrentFirmGst = currentFirm ? this.firmSelectionService.isGstFirm(currentFirm.status, currentFirm.name) : true;

      if ((!currentFirm || isCurrentFirmGst) && firms.length > 0) {
        const nonGstFirm = firms.find((f: any) => !this.firmSelectionService.isGstFirm(f.gst_status, f.name));
        if (nonGstFirm) {
          this.selectedFirm = nonGstFirm.name;
          this.firmSelectionService.setselectedFirmName({ id: nonGstFirm.id, name: nonGstFirm.name, status: nonGstFirm.gst_status });
        } else {
          const defaultFirm = firms[0];
          this.selectedFirm = defaultFirm.name;
          this.firmSelectionService.setselectedFirmName({ id: defaultFirm.id, name: defaultFirm.name, status: defaultFirm.gst_status });
        }
      }
    });
  }

  isUserMenuOpen = false;
  toggleUserMenu(): void { this.isUserMenuOpen = !this.isUserMenuOpen; }
  onFocusOut(event: FocusEvent): void {
    const currentTarget = event.currentTarget as HTMLElement | null;
    const relatedTarget = event.relatedTarget as HTMLElement | null;
    if (!currentTarget) { this.isUserMenuOpen = false; return; }
    if (!relatedTarget || !currentTarget.contains(relatedTarget)) { this.isUserMenuOpen = false; }
  }

  logout(): void {
    this.isUserMenuOpen = false;
    this.notificationService.showSuccess('Logged out successfully.', 'Logout');
    this.authService.logout();
  }
}